import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import { Lock } from "lucide-react";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import API_URL from "../../api/API";

const ACTION_TYPES = [
  { value: "block", label: "Block Service" },
  { value: "warn", label: "Show Warning" },
  { value: "proceed", label: "Continue" }
];

const ACTION_STYLES = {
  block: "bg-red-100 text-red-700 border-red-200",
  warn: "bg-yellow-100 text-yellow-700 border-yellow-200",
  proceed: "bg-green-100 text-green-700 border-green-200",
};

const WaiverEligibilityRules = () => {

  const { waiver } = useOutletContext();  
  const { business } = useBusinessAuthContext();

  const navigate = useNavigate();  
  const { waiverId } = useParams();

  const [waiver_data, setWaiver] = useState(null); 
  const [eligibility, setEligibility] = useState(null);
  const [questions, setQuestions] = useState([]);  
  const [customQuestions, setCustomQuestions] = useState([]);



  const [loading, setLoading] = useState(true);
  const isReadOnly = true;

  // Load existing waiver data
  useEffect(() => {
    if (!business) {
      navigate("/business/login");
      return;
    }

    const fetchWaiver = async () => {
      try {
        const res = await fetch(
          `${API_URL.BUSINESS_WAIVER_BY_ID}/${waiverId}`,
          {
            headers: {
                Authorization: `Bearer ${business.token}`,
                "x-session-id": business.sessionId,               
                "x-frontend-url": window.location.pathname  
            },
          }
        );

        const data = await res.json();

        if (data.success) {          
          setWaiver(data.waiver);
        }
      } catch (err) {
        console.error("Failed to load waiver", err);
      } finally {
        setLoading(false);
      }
    };

    fetchWaiver();
  }, [business, waiverId, navigate]);

  // Fetch eligibility
  useEffect(() => {

    if (!business) {
      navigate("/business/login");
      return;
    }

    const fetchEligibility = async () => {
      try {

        const res = await fetch(
          `${API_URL.BUSINESS_ELIGIBILITY_BY_WAIVER}/${waiverId}`,
          {
            headers: {
                Authorization: `Bearer ${business.token}`,
                "x-session-id": business.sessionId,                 
                "x-frontend-url": window.location.pathname  
            }
          }
        );

        const data = await res.json();

        if (data.success) {

          const q = (data.eligibility.questions || []).map(question => ({
            ...question,
            question: question.question_adult_full,
            options: question.options_adult_full || []
          }));

          const system = q.filter(x => !x.customQuestion);
          const custom = q.filter(x => x.customQuestion);

          setEligibility(data.eligibility);
          setQuestions(system);
          setCustomQuestions(custom);         


        }

      } catch (err) {
        console.error("Failed loading eligibility", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEligibility();

  }, [business, waiverId, navigate]);


  if (loading) {
    return (
      <div className="p-8">
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h2 className="text-2xl font-semibold mb-6">
        Eligibility Rules
      </h2>

       {/* REQUIRED QUESTIONS */}      
        <div className="bg-white rounded-xl shadow-sm p-6 mb-6">

           
            {questions.map((q, qi) => (

            <div key={q._id || qi} className="mb-6">

                <div className="text-sm font-medium mb-2">
                {q.question}
                </div>

                {(q.options || []).map((opt, oi) => (

                <div
                    key={opt._id || oi}
                    className="flex items-center justify-between border rounded-lg px-4 py-3 mb-2"
                >

                    <span className="text-sm">
                    {opt.label}
                    </span>

                    <div className="flex items-center gap-2">
                    <select
                        value={opt.type}
                        
                        disabled={isReadOnly}
                        
                        className={`border rounded-full px-3 py-1 text-sm font-medium ${ACTION_STYLES[opt.type]}`}
                    >
                        {ACTION_TYPES.map(a => (
                        <option key={a.value} value={a.value}>
                            {a.label}
                        </option>
                        ))}
                    </select>

                    {!q.customQuestion && (
                        <Lock size={14} className="text-gray-400" />
                    )}
                                        
                    </div>

                </div>

                ))}

            </div>

            ))}

        </div>



        {/* CUSTOM QUESTIONS */}

        <div className="bg-white rounded-xl shadow-sm p-6">

            <div className="font-semibold mb-4">
            Custom Questions (Optional)
            </div>

            {customQuestions.map((q, qi) => (

            <div
                key={qi}
                className="border rounded-lg px-4 py-3 mb-3"
            >

                <div className="flex justify-between mb-2">

                <span>{q.question}</span>

               
                </div>

                {(q.options || []).map((opt, oi) => (

                <div
                    key={oi}
                    className="flex justify-between items-center border rounded-md px-3 py-2 mb-2"
                >

                    <span>{opt.label}</span>

                    <select
                    value={opt.type}
                    disabled={isReadOnly}
                    onChange={(e) => {

                        const updated = [...customQuestions];
                        updated[qi].options[oi].type = e.target.value;

                        setCustomQuestions(updated);

                    }}
                    className={`border rounded-full px-3 py-1 text-sm ${ACTION_STYLES[opt.type]}`}
                    >
                    {ACTION_TYPES.map(a => (
                        <option key={a.value} value={a.value}>
                        {a.label}
                        </option>
                    ))}
                    </select>

                </div>

                ))}

            </div>

            ))}
         
        </div>      
    
    </div>
  );
};

export default WaiverEligibilityRules;